/**
 * Task #2425 — cross-component refresh signal for the header's unread
 * notification badge.
 *
 * The header's unread count is normally refreshed by a Supabase realtime
 * `postgres_changes` subscription on the `notifications` table. When that
 * channel isn't connected (no Supabase client configured, websocket dropped,
 * table not in the realtime publication, missed event, etc.) mutating
 * notifications via REST — e.g. dismissing the last one on /notifications —
 * leaves the badge stale until the next full page load.
 *
 * This module exposes a tiny in-app pub/sub so any code that mutates
 * notifications can ping the header to recount, independent of realtime.
 */

type Listener = () => void;

const listeners = new Set<Listener>();

export function onNotificationsChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitNotificationsChanged(): void {
  for (const listener of listeners) {
    try {
      listener();
    } catch (err) {
      console.warn("[notifications-events] listener threw:", err);
    }
  }
}
